// local
// export const API_URL = 'http://api.supersticion.com.mx/';

// prod
export const API_URL = 'https://api.supersticion.mx/';
